<script>
export default {
  mounted() {
    window.addStepChangeEvent = (step, operation) => {
      this.$store.commit('cro/addStepChangeEvent', { step, operation });
    };

    window.addQuestionChangeEvent = (question, operation) => {
      this.$store.commit('cro/addQuestionChangeEvent', { question, operation });
    };

    window.addBeforeFormSubmitEvent = operation => {
      this.$store.commit('cro/addBeforeFormSubmitEvent', operation);
    };
  },
};
</script>
